import { useEffect, useRef, useState } from "react";

export function useUsageHistoryFilters({ lookups, filtersState, setFilterOptions, handleFilterChange, handleApplyFilters, skipAutoDateInit = false }) {
	const lastSeasonIdRef = useRef(null);
	const seasonInitializedRef = useRef(false);
	const [pendingApply, setPendingApply] = useState(false);
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		if (!lookups) return;

		if (lookups.products) {
			setFilterOptions("product_id", lookups.products, false);
		}

		if (lookups.estates_parents) {
			setFilterOptions("estate_parent_id", lookups.estates_parents, false);
		}

		if (lookups.business_centers) {
			setFilterOptions("business_center_id", lookups.business_centers, false);
		}

		if (lookups.operators) {
			setFilterOptions("operator_id", lookups.operators, false);
		}

		if (lookups.type_oa_customer) {
			setFilterOptions("type_oa_id", lookups.type_oa_customer, false);
		}

		if (lookups.seasons) {
			setFilterOptions("season_id", lookups.seasons, false);

			if (!seasonInitializedRef.current && handleFilterChange) {
				const activeSeason = lookups.seasons.find((s) => s.active === true || s.active === 1);

				if (activeSeason) {
					handleFilterChange("season_id", activeSeason.value);

					if (!skipAutoDateInit) {
						if (activeSeason.start_date) {
							handleFilterChange("date_from", activeSeason.start_date);
						}
						if (activeSeason.end_date) {
							handleFilterChange("date_to", activeSeason.end_date);
						}
					}

					seasonInitializedRef.current = true;
					setPendingApply(true);
					return;
				} else {
					seasonInitializedRef.current = true;
				}
			}
		}

		setIsReady(true);
	}, [lookups, setFilterOptions, handleFilterChange, skipAutoDateInit]);

	useEffect(() => {
		if (pendingApply && handleApplyFilters && filtersState) {
			const seasonFilter = filtersState.find((f) => f.key === "season_id");
			const dateFromFilter = filtersState.find((f) => f.key === "date_from");

			if (seasonFilter?.value && dateFromFilter?.value) {
				handleApplyFilters();
				setPendingApply(false);
				setIsReady(true);
				lastSeasonIdRef.current = seasonFilter.value;
			}
		}
	}, [pendingApply, filtersState, handleApplyFilters]);

	useEffect(() => {
		if (!lookups?.seasons || !filtersState || !handleFilterChange) return;
		if (!seasonInitializedRef.current || pendingApply) return;

		const seasonFilter = filtersState.find((f) => f.key === "season_id");
		const currentSeasonId = seasonFilter?.value;

		if (currentSeasonId === lastSeasonIdRef.current) return;
		lastSeasonIdRef.current = currentSeasonId;

		if (!currentSeasonId) return;

		const selectedSeason = lookups.seasons.find((s) => String(s.value) === String(currentSeasonId));

		if (!selectedSeason) return;

		if (selectedSeason.start_date) {
			handleFilterChange("date_from", selectedSeason.start_date);
		}
		if (selectedSeason.end_date) {
			handleFilterChange("date_to", selectedSeason.end_date);
		}
	}, [lookups?.seasons, filtersState, handleFilterChange, pendingApply]);

	return { isReady };
}
